module.exports = __webpack_public_path__ + "media/staff/kim-dallum-medical-ministry-9efd9e73.jpg";